<template>
  <ContentWrapperControl class="mt-4">
    <div class="bg-white p-4 rounded shadow overflow-hidden">
      <!-- <img v-bind:src="image" class="block w-full" /> -->
      <div class="flex flex-col items-center justify-center">
        <img class="w-48 h-48 mb-5" src="https://resource.pafcpic.net/assets/pia/images/elements/papsi-kara.png" />
        <div class="flex flex-col text-sm overflow-clip w-full">
          <div class="mb-3 bg-grey-lighter p-5 rounded-lg shadow-sm">
            <p class="font-semibold mb-1">Office Hours</p>
            <p>Monday to Friday <br />9:00 AM to 4:00 PM (Except Holidays)</p>
          </div>
          <div class="mb-3 bg-grey-lighter p-5 rounded-lg shadow-sm">
            <p class="font-semibold mb-1">Email Address</p>
            <p>customer@pafcpic365.com</p>
          </div>
          <div class="bg-grey-lighter p-5 rounded-lg shadow-sm">
            <p class="font-semibold mb-1">Mobile Number</p>
            <p>(+63) 998-588-1969</p>
          </div>
        </div>
      </div>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ContentWrapperControl,
  },
  data() {
    return {
      image: "",
    };
  },
  mounted() {
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000132"),
      show: true,
      back: true,
    });
    this.$emit("nofooter", false);
    this.image = this.getMediaPath("/misc/contact-us-sm.jpg");
  },
};
</script>
